import React, { useMemo } from "react"
import CompetitiveGraph from './CompetitiveGraph'
import { NoContent } from '../../utils/tools'
import { Divider, Skeleton } from '@mui/material'
import { GarphProvider } from "../../context/graphContext"
import { useSection } from "../../context/section"
import axios from "axios"

const getFrequencyByIndex = (index, dataset) => {
    return dataset.find(data => data.index === index) 
}

export default function CompetitiveGraphConatiner({graphsId, dataset}) {
    const { getDatasetIndex } = useSection()

    const initialGraph = {
        fig: null,
        displayMethod:'NONE',
        normalization:'NONE',
        datasetValue: dataset[0]?.datasetValue,
        columnValue: dataset[0]?.columnValue, 
        index: dataset[0]?.index,
        agg: dataset[0]?.agg,
        group: dataset[0]?.group
    }

    const getGraph = async (graphId) => {
        // const resJson = await fetch(`/api/getGraph?graphId=${graphId}`)
        const resJson = await axios.get(`/api/getGraph?graphId=${graphId}`)
        const res = await resJson.data
        const { column:columnValue, dataset:datasetValue, layers:fig, displayMethod, normalization, timeFrame, agg, group } = res
        return { datasetValue,
            columnValue,
            fig,
            displayMethod,
            normalization,
            index: getDatasetIndex(datasetValue, columnValue, agg, group),
            timeFrame,
            timeRange: res.timeRange || 'ALL',
            agg,
            group,
        }
    }

    const getGraphFunction = async (data, graphId) => {
        const {displayMethod ,normalization, datasetValue, columnValue, index, timeFrame, timeRange} = data
        const aggFunction = getFrequencyByIndex(index, dataset)
        // const resJson = await fetch('/api/getCompetitionGraphFunction', {
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({displayMethod ,normalization, graphId, datasetValue, columnValue, aggFunctions: {agg:aggFunction.agg, group:aggFunction.group}, timeFrame, timeRange})
        // })
        const resJson = await axios({
            method: 'post',
            url: '/api/getCompetitionGraphFunction',
            data: {displayMethod ,normalization, graphId, datasetValue, columnValue, aggFunctions: {agg:aggFunction.agg, group:aggFunction.group}, timeFrame, timeRange}
        })
        const res = await resJson.data
        return {...data, displayMethod ,normalization, datasetValue, columnValue, index, fig: res.layers}
    }
    
    const renderGraphs=(graphId)=> (
        <GarphProvider key={graphId} graphId={graphId} getGraphFunction={getGraphFunction} getGraph={getGraph} initialGraph={initialGraph}>
            <CompetitiveGraph key={graphId} graphId={graphId} dataset={dataset}/>
        </GarphProvider>
    )

    const graphs = useMemo(()=>{
        if(!graphsId) { 
            return <Skeleton width='100%' height='500px'/>
        }
        let graph_array =  graphsId.flatMap((graphId, index) => ([renderGraphs(graphId),<Divider key={`divider-${index}`}/>]))
        graph_array.splice(-1, 1)
        return graph_array
    }, [graphsId]) // eslint-disable-line

    return ( 
    <div className='graph'>
        { dataset.length ? graphs : <NoContent />}
    </div> )
}   
